import React from 'react'

export default function Section3() {
  return (
    <div className=' p-2 '>
        <div className='md:flex md:items-center h-40 m-10 apect-1 shadow-xl shadow-slate-400 rounded-md md:justify-center  '>
            <p className='px-6 py-4'>Are you a grocery chain that wants to work with Flashfood?</p>
            <button className='bg-bg shadow-shdow p-1 text-white rounded-md shadow-[6px_6px_0_0]'>LEARN MORE</button>
        </div>
    </div>
  )
}
